module.exports = __webpack_public_path__ + "img/title.d03c4745.png";